<template>
  <div id="Footer"></div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
